import * as React from 'react'

type Props = {
  id: string
  required?: boolean
}

class PhoneInput extends React.Component<Props> {
  componentDidMount(): void {
    // todo: this is some crappy code, could we fix this?
    ;(window as any).$(`#${this.props.id} input`).intlTelInput({
      initialCountry: 'gl',
      utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/13.0.2/js/utils.js',
      hiddenInput: 'mobileNumber'
    })
    ;(window as any).$('.intl-tel-input').css({
      width: '100%'
    })
  }

  componentWillUnmount(): void {
    ;(window as any).$(`#${this.props.id} input`).intlTelInput('destroy')
  }

  render() {
    return <div id={this.props.id}>{this.props.children}</div>
  }
}

export default PhoneInput
